import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import { isMobile } from "react-device-detect";
import Volume from "./Volume";
import Teenpattit20Result from "../../client/tp-studio/tp-result/Teenpattit20-Result.jsx";
import TpRules from "./pop-up/tp-rules.jsx";
import OneCardRules from "./pop-up/onecard20-rules";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import OneCardResult from "./tp-result/OneCard2020Result.jsx";

export default function OneCard2020() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);

  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [b3Val, setB3Val] = useState(0);
  const [b4Val, setB4Val] = useState(0);

  const [pairAVal, setPairAVal] = useState(0);
  const [pairBVal, setPairBVal] = useState(0);
  const [lastStatus, setLastStatus] = useState(null);
  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [roundId, setRoundId] = useState("");

  const [winnerA, setWinnerA] = useState(false);
  const [winnerB, setWinnerB] = useState(false);
  const [winnerC, setWinnerC] = useState(false);
  const [winnerD, setWinnerD] = useState(false);

  const [isPair1, setIsPair1] = useState(false);
  const [isPair2, setIsPair2] = useState(false);

  const [playerABook, setPlayerABook] = useState(0);
  const [playerBBook, setPlayerBBook] = useState(0);
  const [playerCBook, setPlayerCBook] = useState(0);

  const [playerAPlusBook, setPlayerAPlusBook] = useState(0);
  const [playerBPlusBook, setPlayerBPlusBook] = useState(0);
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  const [resultData, setResultData] = useState([]);

  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  const flipTimerRef = useRef(null);
  const cardsSettleTimerRef = useRef(null);
  const revealStartedForRef = useRef(null);
  const [shownAc1, setShownAc1] = useState("1");
  const [shownAc2, setShownAc2] = useState("1");
  const [cardsSettled, setCardsSettled] = useState(false);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  /* ================= DISPLAYED CARDS (IMPORTANT) ================= */
  const [shownCards, setShownCards] = useState({
    ac1: "1",
    ac2: "1",
    ac3: "1",
    bc1: "1",
    bc2: "1",
    bc3: "1"
  });

  const [shownCards1, setShownCards1] = useState({
    ac1: "1",
    ac2: "1",
    ac3: "1"
  });

  const [shownCards2, setShownCards2] = useState({
    bc1: "1",
    bc2: "1",
    bc3: "1"
  });

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "onecard20_virtual"
  });

  //console.log(data);

  const displayRunnerName = (runnerName) => {
    if (runnerName === "b1") {
      return "Player";
    } else if (runnerName === "b2") {
      return "Dealer";
    } else if (runnerName === "b3") {
      return "Tie";
    }
  };

  /// place bet ///

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          setShowBetSlipPopup(false);
          getPlacedBets();
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;
  const [displayLoader, setDisplayLoader] = useState(true);
  //console.log("payload->", payload);

  /* ================= TIMER SYNC ================= */
  useEffect(() => {
    if (!payload) return;
    updateUserData(data?.user);
    setDisplayLoader(false);

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]); //clearing placed bets on status change
      setWinnerA(false);
      setWinnerB(false);
      setWinnerC(false);
      setWinnerD(false);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);

      setIsPair1(false);
      setIsPair2(false);
      setPlayerABook(0);
      setPlayerBBook(0);
      setPlayerCBook(0);
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds !== "number") return;

    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setB3Val(payload?.b3);
    setB4Val(payload?.b4);

    //setPairAVal(payload?.pairA);
    //setPairBVal(payload?.pairB);
    setTimeLeft(serverSeconds);
    setRoundId(payload?.cat_mid);

    if (payload?.result == 1) {
      setWinnerA(true);
      setWinnerB(false);
      setWinnerC(false);
    } else if (payload?.result == 2) {
      setWinnerA(false);
      setWinnerB(true);
      setWinnerC(false);
    } else if (payload?.result == 3) {
      setWinnerA(false);
      setWinnerB(false);
      setWinnerC(true);
    }

    if (payload?.isPair1 == 1) {
      setIsPair1(true);
      setWinnerD(true);
    } else {
      setIsPair1(false);
      setWinnerD(false);
    }
    if (payload?.isPair2 == 1) {
      setIsPair2(true);
    } else {
      setIsPair2(false);
    }

    clearInterval(localTimerRef.current);

    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "onecard20_virtual"
    });
    let books = res?.data;

    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];
        setPlayerABook(obj.PlayerA);
        setPlayerBBook(obj.PlayerB);
        setPlayerCBook(obj.PlayerC);
      }
    }
  }

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (payload.evt_status === "OPEN") {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
      revealStartedForRef.current = null;
      setShownAc1("1");
      setShownAc2("1");
      setCardsSettled(false);
      return;
    }

    if (payload.evt_status === "CLOSED") {
      const c1 = payload?.ac1;
      const c2 = payload?.ac2;

      // Wait until the Player card is a real value
      if (!c1 || c1 === "1") return;

      const roundKey = `${c1}|${c2}`;
      if (revealStartedForRef.current === roundKey) return;
      revealStartedForRef.current = roundKey;

      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
      setShownAc1("1");
      setShownAc2("1");
      setCardsSettled(false);

      let cancelled = false;

      function revealPlayer() {
        if (cancelled) return;
        setShownAc1(c1);
        flipTimerRef.current = setTimeout(revealDealer, 1000);
      }
      function revealDealer() {
        if (cancelled) return;
        setShownAc2(c2);
        clearTimeout(cardsSettleTimerRef.current);
        cardsSettleTimerRef.current = setTimeout(() => {
          if (!cancelled) setCardsSettled(true);
        }, 1000);
      }

      flipTimerRef.current = setTimeout(revealPlayer, 300);

      return () => {
        cancelled = true;
        clearTimeout(flipTimerRef.current);
        clearTimeout(cardsSettleTimerRef.current);
      };
    }
  }, [payload?.evt_status, payload?.ac1, payload?.ac2]);

  useEffect(
    () => () => {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    },
    []
  );

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  const showBetfairBetSlip = (bettype, teamname, selectRnr, price) => {
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "onecard20_virtual"
    };
    placeBetObject.catmid = payload?.cat_mid;
    placeBetObject.round = payload?.cat_mid;

    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 7;

    setPlaceBetObject(placeBetObject);

    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };
  /// place bet ///
  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };
  const closeBetSlip = () => {
    setShowBetSlip(false);
  };
  const [profileData, setProfileData] = useState(null);

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const [initialBetsFetched, setInitialBetsFetched] = useState(false);
  const [placedBets, setPlacedBets] = useState([]);
  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const placedBets = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "onecard20_virtual"
    });

    setPlacedBets(placedBets.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  const getCardImage = (cardValue, reveal) => {
    return reveal && cardValue && cardValue !== "1" ? cardValue : "1";
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "onecard20_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);
    //console.log("FULL RESPONSE", response.data);
    //console.log("AFTER API CALL");
    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  return (
    <div className="aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div>
                          {" "}
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>ONE CARD 20-20</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <OneCardRules
                          show={showRules}
                          onClose={() => setShowRules(false)}
                        />
                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div>
                            <div
                              className="cards-layout blackjack"
                              style={{ position: "relative" }}
                            >
                              <div className="col-12 timerDiv2 mb-negative-24">
                                <div
                                  className="row mt-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div className="col-2 col-md-1">
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          53
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="col-md-8"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                />

                                <div
                                  className="col-md-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  {/* Timer with animated stroke + numeric countdown */}
                                  <div className="teenpatti-base-timer">
                                    <svg
                                      viewBox="0 0 100 100"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        />
                                        <path
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          className={`base-timer__path-remaining ${timerColor}`}
                                          d="
                                            M 50, 50
                                            m -45, 0
                                            a 45,45 0 1,0 90,0
                                            a 45,45 0 1,0 -90,0
                                          "
                                        />
                                      </g>
                                    </svg>
                                    <span className="base-timer__label">
                                      {timeLeft == 1 ? 0 : timeLeft}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="three-cards-wrapper">
                                <div class="player-containerHC">
                                  <div class="player-itemHC">
                                    <span class="player-nameHC">PLAYER</span>
                                    <div class="player-cardHC">
                                      <div
                                        id="BFBCardFanView"
                                        class="card-viewHC"
                                      >
                                        <div
                                          xclass="open_cardTP sprite-card-chs-card svg-card_simple_1-dims d-card trans_10 svg-card_simple_1"
                                          style={{ marginRight: "0px" }}
                                        >
                                          <img
                                            src={`/assets/images/cards/${getCardImage(
                                              shownAc1,
                                              true
                                            )}.svg`}
                                            draggable={false}
                                            style={{
                                              width: isMobile ? "46px" : "60px",
                                              height: isMobile ? "55px" : "75px"
                                            }}
                                            className="animate__animated animate__flipInY"
                                            key={shownAc1}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="player-containerHC">
                                  <div class="player-itemHC">
                                    <span class="player-nameHC">DEALER</span>
                                    <div class="player-cardHC">
                                      <div
                                        id="BFBCardFanView"
                                        class="card-viewHC"
                                      >
                                        <div
                                          xclass="open_cardTP sprite-card-chs-card svg-card_simple_1-dims d-card trans_10 svg-card_simple_26"
                                          style={{ marginRight: "0px" }}
                                        >
                                          <img
                                            src={`/assets/images/cards/${getCardImage(
                                              shownAc2,
                                              true
                                            )}.svg`}
                                            draggable={false}
                                            style={{
                                              width: isMobile ? "46px" : "60px",
                                              height: isMobile ? "55px" : "75px"
                                            }}
                                            className="animate__animated animate__flipInY"
                                            key={shownAc2}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <Volume
                                id="OneCard2020Soundcontrol"
                                style={{
                                  position: "absolute",
                                  right: 8,
                                  bottom: 8,
                                  zIndex: 100,
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              />
                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <center
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {Object.keys(resultList).map((idx) => (
                                <button
                                  key={idx}
                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {resultList[idx] == 1 ? "A" : "B"}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </center>

                        {/* Market Sections (unchanged) */}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>MATCH ODDS </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3
                                  className={
                                    winnerA && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b1Sucess"
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Player
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    playerABook !== 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    playerABook > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(playerABook)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Player"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "player",
                                        "player",
                                        b1Val
                                      )
                                    }
                                  >
                                    {b1Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  className={
                                    winnerB && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b1Sucess"
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Dealer
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    playerBBook !== 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    playerBBook > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(playerBBook)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}

                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Dealer"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "dealer",
                                        "dealer",
                                        b2Val
                                      )
                                    }
                                  >
                                    {b2Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <span class="price-odd"></span>
                                    <span class="price-amount"></span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  className={
                                    winnerC && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b1Sucess"
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Tie
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  float: "left",
                                                  display:
                                                    playerCBook !== 0
                                                      ? ""
                                                      : "none",
                                                  color:
                                                    playerCBook > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(playerCBook)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Tie"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "tie",
                                        "tie",
                                        b3Val
                                      )
                                    }
                                  >
                                    {b3Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <span class="price-odd"></span>
                                    <span class="price-amount"></span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{ height: "5px", backgroundColor: "#000" }}
                          ></div>
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>PAIR </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3 class="runner-name" id="b1Sucess">
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h3
                                                style={{ fontWeight: "bold" }}
                                                className={
                                                  isPair1 && cardsSettled
                                                    ? "runner-name sussesBg"
                                                    : "runner-name"
                                                }
                                                id="b1Sucess"
                                              >
                                                Pair
                                              </h3>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Pair"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "pair",
                                        "pair",
                                        b4Val
                                      )
                                    }
                                  >
                                    {b4Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <span class="price-odd"></span>
                                    <span class="price-amount"></span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <OneCardResult resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-md-4 mobile-margin">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}

                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong style={{ fontSize: "16px" }}>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr style={{ fontSize: "16px" }}>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - (
                                        {bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`
          .player-containerHC {
            display: inline-flex;
            flex-direction: column;
            margin: 5px;
          }
          .three-cards-wrapper{
            display:flex;
            justify-content:center;
            align-items:flex-start;
            gap:1px;
            width:100%;
            margin-top: 0;
          }
          .volume-wrapper {
            margin-top: -25px;
          }
          @media (min-width: 992px) {
            .aviator-scope .row {
              margin-left: 0 !important;
              margin-right: 0 !important;
            }
          }
          @scope (.aviator-scope) {
            .cards-layout.blackjack {
              position: relative;
              min-height: 210px;
              background: #000000 !important;
            }
            .cards-layout.blackjack::before {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background: radial-gradient(
                ellipse 100% 44% at 50% calc(30% + 40px),
                rgba(62, 193, 65, 0.95) 0%,
                rgba(62, 193, 65, 0.8) 15%,
                rgba(30, 80, 35, 0.5) 40%,
                #1e1e1e 55%,
                #1e1e1e 100%
              );
              opacity: 0.4;
              pointer-events: none;
              z-index: 0;
            }
            .cards-layout.blackjack > * {
              position: relative;
              z-index: 1;
            }
            .blackjack {
              background: #000000 !important;
            }
            .timerDiv2 {
              padding-left: 5px;
              padding-top: 0;
            }
            .timerDiv2 .Connectedclients {
              position: relative;
              top: -5px;
              left: -3px;
            }
            .timerDiv2 .col-md-2 {
              position: relative;
              top: -32px;
              left: 12px;
            }
            .timerDiv2 .teenpatti-base-timer {
              position: relative;
              width: 50px;
            }
            .cards-layout.blackjack .sound-icon {
              transform: scale(0.9) translateX(-10px);
              transform-origin: center;
            }
          }
          @media (max-width: 576px) {
            .aviator-scope .timerDiv2 .Connectedclients {
              top: -2px;
              left: 9px;
            }
            .mobile-margin{
              margin-top: 8px;
            }
          }
            .mobile-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,0.5);
                        z-index: 9999;
                    }
                    .mobile-modal {
                        position: fixed;
                        top: 10px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 95%;
                        max-width: 420px;
                        background: #dfe7ee; 
                        border-radius: 6px;
                        padding: 15px;
                        box-shadow: 0 4px 15px rgba(0,0,0,0.3);
                        animation: slideDown 0.25s ease;
                    }
                    @keyframes slideDown {
                        from {
                            transform: translate(-50%, -30%);
                            opacity: 0;
                        }
                        to {
                            transform: translate(-50%, 0);
                            opacity: 1;
                        }
                    }
            
          `}
      </style>
    </div>
  );
}
